import { FixaOverflowCarousel } from "@coworker/apprestructured/src/shared/wrappers/FixaCarousel/FixaCarousel";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./LoadingCarousel.module.css";

function LoadingCarousel() {
  return (
    <FixaOverflowCarousel id="loading-carousel">
      <FixaSkeleton
        width="100px"
        height="135px"
        className={styles["rightMargin"]}
      />
      <FixaSkeleton
        width="100px"
        height="135px"
        className={styles["rightMargin"]}
      />
      <FixaSkeleton width="100px" height="135px" />
    </FixaOverflowCarousel>
  );
}

export default LoadingCarousel;
